import { LANGUAGES } from './constants';

export const getLangFromURL = () => {
  const params = new URLSearchParams(document.location.search);
  const language = params.get('lang')?.toLowerCase();

  return language === LANGUAGES.en ? LANGUAGES.en : LANGUAGES.es;
};
